export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7599.6f0adb3c.jpg";